import Styles from './BatchModals.module.scss'
import { Images } from './Images'
import { Topic } from './Topic'
import { MinimalMediaFile } from '../../Types'

interface TopicAndImagesProps {
  topic: string
  setTopic: (topic: string) => void
  mediaFiles: MinimalMediaFile[]
  setMediaFiles: React.Dispatch<React.SetStateAction<MinimalMediaFile[]>>
  setIsProcessing: (isProcessing: boolean) => void
}

export const TopicAndImages = ({
  topic,
  setTopic,
  mediaFiles,
  setMediaFiles,
  setIsProcessing,
}: TopicAndImagesProps) => {
  return (
    <div className={Styles.topicAndImages}>
      <Topic topic={topic} setTopic={setTopic} />
      <Images mediaFiles={mediaFiles} setMediaFiles={setMediaFiles} setIsProcessing={setIsProcessing} />
    </div>
  )
}
